module.exports = __webpack_public_path__ + "france.2648a71e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/flags/france.png
// module id = 1496
// module chunks = 0